export { Menu };

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export var Divider = 'DIVIDER';

/**
 * Menu component
 */
function Menu(_ref) {
  var items = _ref.items,
      children = _ref.children,
      visible = _ref.visible,
      _onClick = _ref.onClick,
      transformX = _ref.transformX,
      transformY = _ref.transformY;

  var hasIcon = false;
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    if (item.icon) {
      hasIcon = true;
      break;
    }
  }

  return React.createElement(
    'div',
    { className: 'mdc-Menu' },
    children,
    React.createElement(
      'ul',
      { className: classnames('mdc-Menu-list', {
          'is-visible': visible
        }), style: {
          top: transformY === 'top' ? 0 : null,
          bottom: transformY === 'bottom' ? 0 : null,
          left: transformX === 'left' ? 0 : null,
          right: transformX === 'right' ? 0 : null,
          transformOrigin: transformX + ' ' + transformY
        } },
      items.map(function (item, index) {
        if (item === Divider) {
          return React.createElement('li', { key: index, className: 'mdc-Menu-divider' });
        }
        return React.createElement(
          'li',
          { key: index, className: classnames('mdc-Menu-list-item', {
              'is-visible': visible
            }) },
          React.createElement(
            'a',
            { href: '#', className: 'mdc-Menu-list-item-link', onClick: function onClick(e) {
                e.preventDefault();
                _onClick(item);
              } },
            hasIcon && React.createElement(
              'div',
              { className: 'mdc-Menu-icon' },
              item.icon
            ),
            item.content || item
          )
        );
      })
    )
  );
}

/**
 * Property types
 */
Menu.propTypes = {
  items: PropTypes.array,
  onClick: PropTypes.func.isRequired,
  visible: PropTypes.bool

  /**
   * Default properties
   */
};Menu.defaultProps = {
  items: ['One', 'Two'],
  visible: false
};


//////////////////
// WEBPACK FOOTER
// ../es/js/menu/index.js
// module id = 288
// module chunks = 0